import { OpenWebLoginButtons } from '@framework/auth-open-web';
import { useTranslation } from '@framework/i18n';
import { useSessionStorageLocation } from '@framework/ui';
import { Divider } from 'antd';
import { ReactNode } from 'react';

export interface ICommonLoginFormProps {
  resolvePublicUrl: (path: string) => string;
  externalLogin?: ReactNode;
  /**
   * Attualmente la pagina di login Frontoffice non utilizza
   * questo componente, quindi potremmo semplicemente rimuovere il parametro e
   * nascondere sempre il login OpenWeb.
   */
  hideOpenWeb?: boolean;
}

/**
 * Form di login per Backoffice e Admin.
 */
export function CommonLoginForm(props: ICommonLoginFormProps) {
  const { resolvePublicUrl, externalLogin, hideOpenWeb } = props;

  useSessionStorageLocation();
  const { t } = useTranslation();

  return (
    <>
      {/* Accesso OpenWeb */}
      {!hideOpenWeb && (
        <>
          <Divider>{t('user.login.title', 'Effettua l’accesso')}</Divider>
          <OpenWebLoginButtons resolvePublicUrl={resolvePublicUrl} />
        </>
      )}

      {/* Accesso utenti extra-eu (username-psw) */}
      {externalLogin ? (
        <Divider>{t('user.login.login-button-or-divider', 'OPPURE')}</Divider>
      ) : (
        <div style={{ marginTop: '20px' }}></div>
      )}
      {externalLogin}

      {/* Accesso dipendenti */}

      <Divider style={{ marginTop: 0 }}>
        {t('user.login.employee-title', 'Effettua l’accesso dipendenti')}
      </Divider>
    </>
  );
}
